import script from "./leftCard3.vue?vue&type=script&setup=true&lang=js"
export * from "./leftCard3.vue?vue&type=script&setup=true&lang=js"

import "./leftCard3.vue?vue&type=style&index=0&id=2830e447&scoped=true&lang=scss"

import exportComponent from "E:\\茂侨项目文件夹\\monitoring-platform\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2830e447"]])

export default __exports__